import defaultLocale from './default'

export default defaultLocale



// WEBPACK FOOTER //
// ./components/locale-provider/en_US.js